import onSubmitDistributor from 'utils/on-submit-distributor/onSubmitDistributor';
import { DistributorRegisterOnSubmitFunction } from '../../createDistributor.type';

const distributorRegisterOnSubmit: DistributorRegisterOnSubmitFunction = payload => {
  return onSubmitDistributor({ method: 'post', ...payload });
};

export default distributorRegisterOnSubmit;
